'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef, Fragment } from 'react';

/**
 * Avatars are used to represent people or entities.
 *
 * @example
 * <Avatar aria-label="John Doe" initials="JD" />
 *
 * @example
 * <Avatar aria-label="John Doe">
 *  <img src='…' alt='John Doe' />
 * </Avatar>
 *
 * @example
 * <Avatar aria-label="John Doe">
 *  <Icon />
 * </Avatar>
 */
const Avatar = forwardRef(function Avatar({ 'aria-label': ariaLabel, 'data-tooltip': dataTooltip, variant = 'circle', className, children, initials, asChild, ...rest }, ref) {
    const OuterComponent = asChild ? Slot : 'span';
    const useSlot = children && typeof children !== 'string';
    const textChild = children && typeof children === 'string';
    const Component = useSlot ? Slot : Fragment;
    return (jsx(OuterComponent, { ref: ref, className: cl('ds-avatar', className), "data-variant": variant, "data-initials": initials, role: asChild ? undefined : 'img', "aria-label": ariaLabel || dataTooltip, "data-tooltip": dataTooltip, tabIndex: dataTooltip ? 0 : undefined, ...rest, children: jsx(Component, { ...(useSlot && !asChild ? { 'aria-hidden': true } : {}), children: textChild ? jsx("span", { children: children }) : children }) }));
});

export { Avatar };
